export enum AttributeCondition {
  UNDEFINED,
  GOOD,
  AVERAGE_GOOD,
  AVERAGE_BAD,
  BAD,
}

export type AttributeValue = string | number | Date | AttributeCondition;

type AttributeType = 'string' | 'number' | 'date' | 'condition' | 'list';

export class AttributeModel {
  constructor(
    public id: string,
    public componentId: string,
    public name: string,
    public value: AttributeValue,
    public type: AttributeType,
    public isEditable: boolean,
    public domainValues: DomainValueModel[]
  ) {
  }
}

export class DomainValueModel {
  constructor(
    public rank: number,
    public code: string,
    public value: string
  ) {
  }
}
